






































import Vue from 'vue'
import axios from 'axios'
import { Product } from '@/models/Product'

export default Vue.extend({
  name: 'ProductForm',

  props: {
    product: Product
  },

  computed: {
    messages(): string | undefined {
      return this.error ? 'パスワードが違います。' : undefined
    }
  },

  data: () => ({
    acckey: String(''),
    error: Boolean(false)
  }),

  methods: {
    onChange() {
      this.error = false
    },
    onSubmitAcckey() {
      this.error = false
      const code = this.product.code
      const password = this.acckey
      // console.log(code, password)
      axios
        .post(`${process.env.VUE_APP_API_URL}certificate`, { code, password })
        .then((res) => {
          if (res.data !== '') {
            const contents = res.data
            console.log(contents)
            this.$store.dispatch('setCertificateInfo', { code, password })
            this.$store.dispatch('setContents', { contents })
            this.$router.push({ name: 'Product', params: { code } })
          } else {
            console.log('certification failed.')
            this.error = true
          }
        })
        .catch((e) => {
          console.error(e)
          this.error = true
        })
    }
  }
})
